import React from 'react';

import {
	ResultLoadingWrapper,
	ResultContainer,
	ResultMainContainer,
	ResultTitleMetadataContainer,
	ResultTitleLoading,
	ResultMetaLoading,
	ResultExcerptLoading,
	ResultIconLoading,
} from './styled.tsx';

export const SearchResultLoading = (): React.JSX.Element => (
	<ResultLoadingWrapper>
		<ResultContainer>
			<ResultMainContainer>
				<ResultIconLoading />
				<ResultTitleMetadataContainer>
					<ResultTitleLoading />
					<ResultMetaLoading />
					<ResultExcerptLoading />
					<ResultExcerptLoading />
				</ResultTitleMetadataContainer>
			</ResultMainContainer>
		</ResultContainer>
	</ResultLoadingWrapper>
);
